import orgModuleStates from "./orgModule/state";
import vendorModuleStates from "./vendorModule/state";

export default {
  ...orgModuleStates,
  ...vendorModuleStates,
  prescribers: [],
};
